import { useTranslation } from "../../localization/useTranslation";
import { useTogglePreselectedOnCreateDialog } from "./TogglePreselectedOnCreateDialog.hooks";
import { DotLegalInfoDialog } from "@dotlegal/dotlegal-ui-components";
import { Trans } from "react-i18next";

export interface ITogglePreselectedOnCreateDialogProps {
    isPreselectedOnCreate: boolean;
    legalEntityId: string;
    companyName: string;
    onCloseDialog: () => void;
    onUpdate: () => void;
}

export function TogglePreselectedOnCreateDialog(props: ITogglePreselectedOnCreateDialogProps) {
    const { toggle, isSaving } = useTogglePreselectedOnCreateDialog(props);
    const { translateString } = useTranslation();

    const header = props.isPreselectedOnCreate ? translateString("removeAsPreselectedOnCreate") : translateString("setAsPreselectedOnCreate");

    return (
        <DotLegalInfoDialog
            btnText={header}
            header={header}
            inProgress={isSaving}
            content={
                props.isPreselectedOnCreate ? (
                    <Trans i18nKey="removeAsPreselectedOnCreateInfo" values={{ name: props.companyName }} />
                ) : (
                    <Trans i18nKey="setAsPreselectedOnCreateInfo" values={{ name: props.companyName }} />
                )
            }
            onBtnClick={() => toggle()}
            onCloseDialog={props.onCloseDialog}
        />
    );
}
